import calculateScrollHeight from 'components/core-adoption/functions/calculateScrollHeight'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import Resource from 'components/global/Resource'
import SectionTitle from 'components/global/SectionTitle'
import { Section, Row, Col } from 'components/grid'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'

export default function AdditionalResources({ ...props }) {
	const { language, account } = useContext(CoreAdoptionContext)
	return (
		<Section margin="mt-40" id={formatSectionId(props)} scrollMarginTop={calculateScrollHeight()}>
			<SectionTitle title={language === 'english' ? 'Additional Resources' : 'Recursos adicionales'} />
			<Row className="items-end justify-center">
				{account?.additional_resources
					.filter((d) => d.active)
					.map((document) => {
						return (
							<Col key={document.name} width="w-1/2 sm:w-1/3 md:w-1/6 mb-6">
								<Resource logResourceView={{ type: 'resource' }} title={document.name} text={document.text} />
							</Col>
						)
					})}
			</Row>
		</Section>
	)
}
